import React from 'react';

export default function FullPdfViewer({ fileUrl }) {
    return (
        <div style={{ width: '100%', height: '100%' }}>
            <embed
                src={fileUrl}
                type="application/pdf"
                width="100%"
                height="100%"
            />
        </div>
    );
}